// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2JWHO","errorLogs":"EditorFooter_errorLogs__3b_Yk"};